import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fs-5 mb-3" }
const _hoisted_2 = { class: "source mb-4" }
const _hoisted_3 = { class: "title d-flex justify-content-between align-items-center mb-2" }
const _hoisted_4 = { class: "fs-6 fw-700 m-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "border border-1 border-dark opacity-100 w-100 ms-2" }, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "badge bg-green rounded-1 fs-6" }
const _hoisted_8 = { class: "fst-italic ms-2" }
const _hoisted_9 = { class: "badge bg-green rounded-1 fs-6" }
const _hoisted_10 = { class: "fst-italic ms-2" }
const _hoisted_11 = {
  key: 1,
  class: "fst-italic"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "delete", -1)
const _hoisted_14 = { class: "target mb-4" }
const _hoisted_15 = { class: "title d-flex justify-content-between align-items-center mb-2" }
const _hoisted_16 = { class: "fs-6 fw-700 m-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", { class: "border border-1 border-dark opacity-100 w-100 ms-2" }, null, -1)
const _hoisted_18 = {
  class: "btn-group w-100 mb-3",
  role: "group",
  "aria-label": "Categorization type"
}
const _hoisted_19 = { class: "buttons row gx-2 align-items-center" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "content_copy", -1)
const _hoisted_23 = { class: "col" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "move_item", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_SelectCategories = _resolveComponent("SelectCategories")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('adjustCategorisation')), 1),
    _createVNode(_component_AlertError2, {
      error: _ctx.categorizationUI.getError(),
      class: "mb-3"
    }, null, 8, ["error"]),
    _createVNode(_component_BaseSpinner, {
      spin: _ctx.categorizationUI.isNotReady()
    }, null, 8, ["spin"]),
    (_ctx.categorizationUI.isReady())
      ? (_openBlock(), _createBlock(_component_dp_form, {
          key: 0,
          as: "form",
          novalidate: "",
          class: "categorization-form"
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('sourceCategory')), 1),
                _hoisted_5
              ]),
              (_ctx.sourceDpManagedCategoryCode || _ctx.sourceInternalCategoryCode)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                    (_ctx.sourceCategorizationType === _ctx.CategorizationTypeEnum.DP_MANAGED)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getDpManagedCategoryName(_ctx.sourceDpManagedCategoryCode)), 1),
                          _createElementVNode("span", _hoisted_8, "(" + _toDisplayString(_ctx.$t('dpManaged')) + ")", 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.sourceCategorizationType === _ctx.CategorizationTypeEnum.INTERNAL)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getInternalCategoryName(_ctx.sourceInternalCategoryCode)), 1),
                          _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(_ctx.$t('internal')) + ")", 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t('notSet')), 1)),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.submitData(_ctx.CategorizationActionEnum.REMOVE)), ["prevent"])),
                class: "btn btn-icon btn-danger",
                disabled: !_ctx.canDeleteCategory
              }, [
                _hoisted_13,
                _createTextVNode(_toDisplayString(_ctx.$t('delete')), 1)
              ], 8, _hoisted_12)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.$t('targetCategory')), 1),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.targetCategorizationType === _ctx.CategorizationTypeEnum.DP_MANAGED}]),
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.targetCategorizationType = _ctx.CategorizationTypeEnum.DP_MANAGED), ["prevent"]))
                }, _toDisplayString(_ctx.$t('dpManaged')), 3),
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-outline-primary", {'active': _ctx.targetCategorizationType === _ctx.CategorizationTypeEnum.INTERNAL}]),
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.targetCategorizationType = _ctx.CategorizationTypeEnum.INTERNAL), ["prevent"]))
                }, _toDisplayString(_ctx.$t('internal')), 3)
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_SelectCategories, {
                  "selected-product-categories": _ctx.productCategoryFilters,
                  "catalog-customer-code": _ctx.catalogCustomerCode,
                  class: "mb-3",
                  "btn-class": "btn btn-icon btn-outline-primary w-100",
                  "btn-icon": "category",
                  onAddCategory: _ctx.addCategory,
                  onRemoveCategory: _ctx.removeCategory
                }, null, 8, ["selected-product-categories", "catalog-customer-code", "onAddCategory", "onRemoveCategory"])
              ], 512), [
                [_vShow, _ctx.targetCategorizationType === _ctx.CategorizationTypeEnum.DP_MANAGED]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_InputSelect, {
                  modelValue: _ctx.targetInternalCategoryCode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetInternalCategoryCode) = $event)),
                  options: _ctx.optionsInternalProductCategory,
                  "can-clear": "",
                  label: _ctx.$t('internalCategory'),
                  name: "filter_category_code_internal",
                  errors: errors
                }, null, 8, ["modelValue", "options", "label", "errors"])
              ], 512), [
                [_vShow, _ctx.targetCategorizationType === _ctx.CategorizationTypeEnum.INTERNAL]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submitData(_ctx.CategorizationActionEnum.COPY)), ["prevent"])),
                  class: "btn btn-icon btn-warning w-100",
                  disabled: !_ctx.canEditCategory
                }, [
                  _hoisted_22,
                  _createTextVNode(_toDisplayString(_ctx.$t('copy')), 1)
                ], 8, _hoisted_21)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitData(_ctx.CategorizationActionEnum.MOVE)), ["prevent"])),
                  class: "btn btn-icon btn-primary w-100",
                  disabled: !_ctx.canEditCategory && !_ctx.canMoveCategoryNotYetCategorized
                }, [
                  _hoisted_25,
                  _createTextVNode(_toDisplayString(_ctx.$t('move')), 1)
                ], 8, _hoisted_24)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}